import React, { useEffect, useMemo, useRef, useState } from 'react'
import TransaksiService from '../../../services/transaksi/TransaksiService'
import UserService from '../../../services/user/UserService'
import { Button, Modal, Spinner } from 'react-bootstrap'
import Disposisi from '../../../utilities/Disposisi'
import SweetAlert from 'react-bootstrap-sweetalert'
import { formatDateString, getCurrentDateFormatted, getCurrentDateTimeFormattedOnly } from '../../../utilities/Utils'
import { AsyncPaginate } from 'react-select-async-paginate'
import UploadService from '../../../services/transaksi/UploadService'
import { QRCodeCanvas } from 'qrcode.react'
import { generatePdfToBlob } from '../../cetak/draft-pdf/GeneratePdfToBlob'

const ModalProsesFinal = ({ showProsesFinal, handleCloseProsesFinal, dataDisposisi, datappm, reloadList }) => {

    // const [qrImage, setQrImage] = useState(null)
    const qrImageCanvas = useRef()
    const [qrText, setQrText] = useState('')

    const getQRCodeDataURL = (canvasRef) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                const canvas = canvasRef.current?.children[0]; // Get the canvas inside <QRCode />
                if (canvas) {
                    resolve(canvas.toDataURL("image/png")); // Convert to Base64
                } else {
                    resolve(null);
                }
            }, 500); // Delay to ensure QR code renders
        });
    };

    // useEffect(() => {
    //     const generateQrCode = async () => {
    //         const dataUrl = await getQRCodeDataURL(qrImageCanvas)
    //         setQrImage(dataUrl)
    //     }
    //     generateQrCode()
    // }, [])

    const generateQrCode = async () => {
        const dataUrl = await getQRCodeDataURL(qrImageCanvas)
        // console.log(dataUrl)
        // setQrImage(dataUrl)
        return dataUrl
    }

    const [showConfirmProsesFinal, setShowConfirmProsesFinal] = useState(false)
    const handleCloseConfirmProsesFinal = () => setShowConfirmProsesFinal(false)
    const [showProsesFinalSuccess, setshowProsesFinalSuccess] = useState(false)
    const [showProsesFinalFailed, setshowProsesFinalFailed] = useState(false)
    const [rowPenugasan, setRowPenugasan] = useState(null)

    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let uploadService = useMemo(() => new UploadService(), [])

    const [dataHc, setDataHc] = useState(null)
    const [dataDisposisiDraft, setDataDisposisiDraft] = useState(null)
    const [valueNoSeri, setValueNoSeri] = useState(null)
    const [valueTglHc, setValueTglHc] = useState(null)
    const [valueTglAju, setValueTglAju] = useState(null)

    const [loadingSave, setLoadingSave] = useState(false)
    const [fileName, setFileName] = useState(null)
    const [urlFile, setUrlFile] = useState(null)

    useEffect(() => {
        if (!datappm && !dataDisposisi) return
        const fetchDataPpm = async () => {
            try {
                const resDisposisiDraft = await transaksiService.listPenugasan(datappm.nomorAju, 9, 0, 10)
                setDataDisposisiDraft(resDisposisiDraft.data.data[0])

                let jsonHcMutu = {
                    nomorAju: datappm.nomorAju,
                    noProses: resDisposisiDraft.data.data[0].noTugas
                }
                const resDataHc = await transaksiService.getHcMutuById(jsonHcMutu)
                setDataHc(resDataHc.data)
                setValueTglHc(formatDateString(resDataHc.data.tglHc))
                setValueTglAju(formatDateString(datappm.tanggalAju))
            } catch (error) {
                // console.log(error)
                setDataHc(null)
            }
        }
        fetchDataPpm()
    }, [datappm, transaksiService, dataDisposisi])

    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }

    const onChangeNoSeri = e => {
        setValueNoSeri(e.target.value)
    }

    const onChangeTglHc = e => {
        const selectedDate = new Date(e.target.value);
        if(selectedDate < new Date(valueTglAju)) {
            alert('Tanggal SMKHP tidak boleh lebih kecil dari Tanggal Aju');
            return
        }
        setValueTglHc(e.target.value)
    }

    const SavePenugasan = (dataDisposisi) => {
        setShowConfirmProsesFinal(true)
        setRowPenugasan(dataDisposisi)

        let filename = 'SMKHP-' + dataHc.noHcMutu + '-' + getCurrentDateTimeFormattedOnly() + '.pdf'
        let urlFile = process.env.REACT_APP_API_URL_FILE + '/view/' + datappm.nomorAju + '/' + filename

        setFileName(filename)
        setQrText(urlFile)
        setUrlFile(urlFile)
    }

    const handleClickProsesFinal = async () => {
        setLoadingSave(true)
        try {
            const now = new Date();
            const [year, month, day] = valueTglHc.split('-');

            // Create new Date with input date and current local time
            const dateWithTime = new Date(
                Number(year),
                Number(month) - 1,
                Number(day),
                now.getHours(),
                now.getMinutes(),
                now.getSeconds(),
                now.getMilliseconds()
            );

            // Format parts
            const yyyy = dateWithTime.getFullYear();
            const MM = String(dateWithTime.getMonth() + 1).padStart(2, '0');
            const dd = String(dateWithTime.getDate()).padStart(2, '0');
            const hh = String(dateWithTime.getHours()).padStart(2, '0');
            const mm = String(dateWithTime.getMinutes()).padStart(2, '0');
            const ss = String(dateWithTime.getSeconds()).padStart(2, '0');
            const ms = String(dateWithTime.getMilliseconds()).padStart(3, '0');

            // Timezone offset in ±HHMM
            const offsetMinutes = dateWithTime.getTimezoneOffset();
            const offsetSign = offsetMinutes > 0 ? '-' : '+';
            const absOffset = Math.abs(offsetMinutes);
            const offsetHH = String(Math.floor(absOffset / 60)).padStart(2, '0');
            const offsetMM = String(absOffset % 60).padStart(2, '0');
            const timezoneOffset = `${offsetSign}${offsetHH}${offsetMM}`;

            const formattedDateTime = `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}.${ms}${timezoneOffset}`;

            const qrImage = await generateQrCode()

            let jsonFinal = { ...rowPenugasan, noTugas: dataDisposisiDraft.noTugas, tglTugas: getCurrentDateFormatted(), nipPejabat: valuePejabatOpt.nip, nmPejabat: valuePejabatOpt.nama, createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resFinal = await transaksiService.addPenugasan(jsonFinal)
            if (_resFinal.data.kode === '200') {
                let dataPpm = { ...datappm, status: '100' }
                await transaksiService.addPpm(dataPpm)

                let dataHcMutu = { ...dataHc, noSeriMutu: valueNoSeri, status: '1', nmPejabat: valuePejabatOpt.nama, nipPejabat: valuePejabatOpt.nip, tglHc: formattedDateTime }
                await transaksiService.addHcMutu(dataHcMutu)

                let dataStatus = {
                    nomorAju: datappm.nomorAju,
                    kodeStatus: '100',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('username')
                }
                await transaksiService.addPpmStatus(JSON.stringify(dataStatus))

                if (datappm.negaraPartner === 'US' || datappm.negaraPartner === 'PR') {
                    try {
                        const noTugas = dataDisposisiDraft?.noTugas
                        const finalFor = '2' // 1 = ki, 2 = fda

                        // Document-ready boundary: generate -> upload -> save-hc-file.
                        // Do not use setTimeout here because the signature workflow is
                        // created from save-hc-file after the TrHcFile transaction commits.
                            const pdfToBlob = await generatePdfToBlob({ datappm, noTugas, qrImage, finalFor })

                            const formData = new FormData()
                            formData.append('file', pdfToBlob, fileName)
                            const resUpload = await uploadService.uploadFileFormData(datappm.nomorAju, formData)

                        if (resUpload.status !== 200) {
                            throw new Error('Upload PDF Final gagal')
                        }

                        const jsonHcFile = {
                                    nomorAju: datappm.nomorAju,
                                    noHcMutu: dataHc.noHcMutu,
                                    noSeriMutuElectronic: dataHc?.noHcMutuExt,
                                    noSeriMutuBlanko: valueNoSeri,
                                    finalFor: finalFor,
                                    dokPath: urlFile,
                                    dokName: fileName,
                                    createdBy: localStorage.getItem("userId"),
                                    createdDate: new Date()
                                }

                        const saveFileRes = await transaksiService.saveSmkhpFile(jsonHcFile)
                        if (saveFileRes?.data?.kode !== '200') {
                            throw new Error('Gagal menyimpan metadata PDF Final')
                            }
                    } catch (error) {
                        console.error('Gagal membuat file Final US/PR:', error)
                        throw error
                    }
                }
                // await transaksiService.sendSmkhpToInsw(datappm.nomorAju)

                setShowConfirmProsesFinal(false)
                setshowProsesFinalSuccess(true)
            } else {
                setShowConfirmProsesFinal(false)
                setshowProsesFinalFailed(true)
            }
        } catch (error) {
            setshowProsesFinalFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickProsesFinalSuccess = () => {
        setshowProsesFinalSuccess(false)
        setShowConfirmProsesFinal(false)
        // window.location.reload()
        reloadList(datappm.nomorAju, 0, 10)
    }

    const handleClickProsesFinalFailed = () => {
        setshowProsesFinalFailed(false)
        setShowConfirmProsesFinal(false)
    }

    return (
        <>
            <div ref={qrImageCanvas} style={{ display: "none" }}>
                <QRCodeCanvas value={qrText} size={100} />
            </div>
            <Modal show={showProsesFinal}
                onHide={handleCloseProsesFinal}
                backdrop='static'
                keyboard={false}
                size="lg"
                centered
            >
                <Modal.Header>
                    <h6><Disposisi idDisposisi={dataDisposisi.idDisposisi} /></h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Pejabat Penandatangan</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPejabatTtd}
                                value={valuePejabatOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePejabatOpt}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Seri Blanko</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomorSeri" value={valueNoSeri} onChange={onChangeNoSeri} />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tanggal SMKHP</label>
                        <div className="col-sm-8">
                            <input type="date" className="col-sm-4 form-control-sm" name="tglHc" value={valueTglHc} onChange={onChangeTglHc} min={valueTglAju}/>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => SavePenugasan(dataDisposisi)}>Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseProsesFinal}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmProsesFinal &&
                <SweetAlert
                    title="Proses SMKHP?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProsesFinal}
                    onCancel={handleCloseConfirmProsesFinal}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProsesFinalSuccess &&
                <SweetAlert
                    title="SMKHP Berhasil Diterbitkan"
                    success
                    onConfirm={handleClickProsesFinalSuccess}
                    btnSize="sm"
                />
            }
            {
                showProsesFinalFailed &&
                <SweetAlert
                    title="SMKHP Gagal Diterbitkan"
                    danger
                    onConfirm={handleClickProsesFinalFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalProsesFinal